import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import DashboardContainer from 'components/DashboardContainer';

import { insights as TEXT } from 'locales/en';

import { getStoreInsights } from 'redux/slices/javelinStore';
import { getRecentOrders, getTopOrder } from 'redux/slices/order';

import RecentDonations from './RecentDonations';
import TopDonation from './TopDonation';
import AverageDonation from './AverageDonation';
import ActiveFundraisers from './ActiveFundraisers';
import TotalRaised from './TotalRaised';

const Insights = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getStoreInsights());
    dispatch(getRecentOrders());
    dispatch(getTopOrder());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    orders_avg_amount: averageDonationAmount,
    orders_total_amount: totalRaised,
    loading: insightsLoading,
  } = useSelector((state) => state.javelinStore.insights);

  const {
    loading: donationsLoading,
    recent: recentDonations,
    top: topDonation,
  } = useSelector((state) => state.order);
  const { loading: fundraisersLoading, liveFundraisers } = useSelector(
    (state) => state.fundraiser
  );

  return (
    <DashboardContainer header={TEXT.header1} subheader={TEXT.header2}>
      <div className="flex flex-col w-full select-none">
        <TotalRaised data={totalRaised} isLoading={insightsLoading} />

        <h2 className="font-bold mt-7 mx-2 mb-2">{TEXT.donations.title}</h2>
        <div className="card rounded lg:grid lg:grid-cols-2 p-0">
          <RecentDonations
            data={recentDonations}
            isLoading={donationsLoading}
          />
          <div className="flex flex-col">
            <TopDonation data={topDonation} isLoading={donationsLoading} />
            <AverageDonation
              data={averageDonationAmount}
              isLoading={insightsLoading}
            />
          </div>
        </div>

        <ActiveFundraisers
          data={liveFundraisers}
          isLoading={fundraisersLoading}
        />
      </div>
    </DashboardContainer>
  );
};

export default Insights;
